import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const publicAxiosClient = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: false,   // no cookies
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor — NO auth token
publicAxiosClient.interceptors.request.use(
  (config) => {
    console.log(`🚀 [PUBLIC] [${config.method?.toUpperCase()}] ${config.baseURL}${config.url}`);
    return config;
  },
  (error) => {
    console.error('❌ Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
publicAxiosClient.interceptors.response.use(
  (response) => {
    console.log('✅ Public response received:', {
      status: response.status,
      url: response.config.url,
    });
    return response.data;
  },
  (error) => {
    console.error('❌ Public API Error:', {
      status: error.response?.status,
      url: error.config?.url,
      message: error.message,
    });
    const message = error.response?.data?.message || error.message || 'Request failed';
    return Promise.reject(new Error(message));
  }
);

export default publicAxiosClient;